module.exports = __webpack_public_path__ + "static/7-838771ef0a2530054ee4b59dbaf01181.jpg";